var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{model:{value:(_vm.string),callback:function ($$v) {_vm.string=$$v},expression:"string"}})
}
var staticRenderFns = []

export { render, staticRenderFns }